<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    class="module-item"
    @click="$emit('click')"
  >
    <q-item-section v-if="withDate" side>
      <date :date="invoice.invoice_date" />
    </q-item-section>
    <q-item-section style="min-width: 0;">
      <q-item-label class="ellipsis">
        <span class="module-name">{{ truncateString(invoice.invoice_number, 20) }}</span>
      </q-item-label>
      <q-item-label
        v-if="invoice.address && compact"
        caption
        class="ellipsis"
      >
        {{ invoice.address.full_address }}
      </q-item-label>
      <q-item-label
        v-if="invoice.overdue_days > 0 || invoice.overdue_paid_days > 0"
        caption
        class="text-red text-bold"
      >
        {{ overdueDaysStr(invoice) }}
      </q-item-label>
      <Status
        flat
        :invoice="invoice"
        class="q-mt-sm lt-sm"
      />
    </q-item-section>
    <q-item-section
      v-if="validClientSlot && invoice.client && !compact"
      class="text-right q-pr-md gt-xs"
      style="max-width: 225px;"
      :title="invoice.client.display_name"
    >
      <q-item-label caption>
        Client
      </q-item-label>
      <div class="text-grey-7 module-name ellipsis">
        {{ truncateString(invoice.client.display_name) }}
      </div>
    </q-item-section>
    <q-separator
      v-if="validClientSlot && !compact"
      vertical
      class="gt-xs"
    />
    <q-item-section
      side
      style="min-width: 90px;"
      class="text-right"
    >
      <q-item-label class="text-bold">
        {{ friendlyNumber(invoice.total, true) }}
      </q-item-label>
    </q-item-section>
    <q-item-section
      side
      :style="compact ? null : 'min-width: 85px;'"
      class="q-pl-sm gt-xs"
    >
      <Status :invoice="invoice" :small="withSmallStatus || compact" />
    </q-item-section>
    <q-item-section
      v-if="hasDefaultSlot"
      side
      :top="top"
      @click="onSideClick"
    >
      <slot />
    </q-item-section>
    <slot
      v-if="hasAfterSlot"
      name="after"
    />
  </q-item>
</template>

<script>
/*
  Partial to display invoice information on any page
*/
import Status from './Status'
import invoiceMixin from 'components/app/invoicing/partials/mixin'
import itemMixin from 'src/helpers/item'

export default {
  components: {
    Status
  },
  mixins: [itemMixin, invoiceMixin],
  props: {
    invoice: {
      required: true,
      type: Object
    },
    top: {
      type: Boolean,
      default: false
    },
    withClient: {
      type: Boolean,
      default: true
    },
    withDate: {
      type: Boolean,
      default: true
    },
    withSmallStatus: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    validClientSlot () {
      return this.invoice.client && this.withClient
    },
    hasContentSlot () {
      return !!this.$slots.content
    },
    hasAfterSlot () {
      return !!this.$slots.after
    },
    hasTitleSlot () {
      return !!this.$slots.title
    }
  },
  methods: {
    onSideClick (e) {
      if (this.preventSideClick) {
        e.stopPropagation()
      }
    }
  }
}
</script>
